import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import BASE_URL from "../../BASEURL";

export default function CouponEdit() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    code: "",
    discount: "",
    expiry: "",
    status: "Active",
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCoupon = async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/coupon/${id}`);
        const data = await res.json();
        if (data.success && data.coupon) {
          const c = data.coupon;
          setForm({
            code: c.code || "",
            discount: c.discountPercentage || "",
            expiry: c.validUntil ? new Date(c.validUntil).toISOString().split("T")[0] : "",
            status: c.isActive ? "Active" : "Inactive",
          });
        }
      } catch (error) {
        console.error("Error fetching coupon:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCoupon();
  }, [id]);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${BASE_URL}/api/coupon/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          code: form.code,
          discountPercentage: Number(form.discount),
          validUntil: new Date(form.expiry),
          isActive: form.status === "Active",
        }),
      });
      const data = await res.json();
      if (data.success) {
        navigate("/admin/coupons");
      } else {
        alert(data.message || "Failed to update coupon");
      }
    } catch (error) {
      console.error("Error updating coupon:", error);
      alert("Error updating coupon");
    }
  };

  if (loading) return <div className="p-6">Loading coupon details...</div>;

  return (
    <div className="bg-white p-6 rounded shadow ">
      <h2 className="text-2xl font-heading font-bold mb-6 text-primary">
        Edit Coupon
      </h2>

      <form className="space-y-5" onSubmit={handleSubmit}>
        <input
          name="code"
          value={form.code}
          onChange={handleChange}
          className="w-full border px-4 py-2 rounded"
        />

        <input
          name="discount"
          type="number"
          value={form.discount}
          onChange={handleChange}
          className="w-full border px-4 py-2 rounded"
        />

        <input
          name="expiry"
          type="date"
          value={form.expiry}
          onChange={handleChange}
          className="w-full border px-4 py-2 rounded"
        />

        <select
          name="status"
          value={form.status}
          onChange={handleChange}
          className="w-full border px-4 py-2 rounded"
        >
          <option>Active</option>
          <option>Inactive</option>
        </select>

        <div className="flex justify-end gap-3 pt-4">
          <button
            type="button"
            onClick={() => navigate("/admin/coupons")}
            className="border px-4 py-2 rounded"
          >
            Cancel
          </button>
          <button className="bg-primary text-white px-5 py-2 rounded">
            Update Coupon
          </button>
        </div>
      </form>
    </div>
  );
}
